import React from 'react'
import {DefaultProps, RefTable} from "../RefTable";


export const DPOSpecialArrangement = (props)=><RefTable {...props}/>;

DPOSpecialArrangement.defaultProps = {
    ...DefaultProps,
    title: "DPO Special Arrangements",
    tableSchema: "dpo_special_arrangement",
    tableName: "dpo_special_arrangement",
    theadHeight: 90,
    edit: true,
}
